import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Table from "react-bootstrap/Table";

import { TableRowElement } from "./";
import { LoadingSpinner } from "../../Shared";
import * as markingApi from "../../../api/markingApi";
import { isEmptyObject } from "../../../util";
import { Subjects, Common } from "../../../helper";

import "../../../assets/stlyes/SubjectOverView/SubjectOverView.scss";

const OverViewTable = () => {
  const markingData = useSelector((state) => state.marking);
  const isclassId = markingData.classId
  const subject = markingData.subjectName
  const year = markingData.year
  const subjectId = markingData.subjectId
  const [result, setResult] = useState();
  const [subjectData, setsubjectData] = useState([]);
  const [pupilAverage, setpupilAverage] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const getSubjectAreaProgress = async () => {
    setIsLoading(true);
    const payload = {
      "id": isclassId,
      "subject": subject,
      "year": year
    }

    if (payload.subject === Subjects.Empty) {
      switch (subjectId.slice(0, 2)) {
      case Subjects.WritingId:
        payload.subject = Subjects.Writing;
        break;
      case Subjects.MathId:
        payload.subject = Subjects.Maths;
        break;
      case Subjects.ReadingId:
        payload.subject = Subjects.Reading;
        break;
      case Subjects.ScienceId:
        payload.subject = Subjects.Science;
        break;
      case Subjects.PEId:
        payload.subject = Subjects.PE;
        break;
      default:
        break;
      }
    }
    const fetchSubject = await markingApi.fetchSubject({ "id": subjectId });
    !isEmptyObject(fetchSubject) && setsubjectData(fetchSubject.Items?.category?.map(c => c.name))
    const _fetchAllCategoryMark = await markingApi.fetchAllCategoryMark(payload);
    !isEmptyObject(_fetchAllCategoryMark) && setResult(_fetchAllCategoryMark.Items)
    !isEmptyObject(_fetchAllCategoryMark) && setpupilAverage(_fetchAllCategoryMark.Items.pupilAverage)
    setIsLoading(false);
  }

  useEffect(() => {
    getSubjectAreaProgress();
  }, [])

  return (
    <>{isLoading ? <LoadingSpinner /> : <Table responsive striped="columns" className="table-main">
      <thead>
        <tr>
          <th style={{ width: "288px" }} className="table"></th>
          {subjectData?.map((categoryName, index) => (
            <th key={index} style={{ width: "98px", marginLeft: "20px", background: (index % 2 !== 0) ? "#FAFAFA" : "", borderRadius: index == 0 ? "15px 0px 0px 0px" : index == (subjectData.length) - 1 ? "0px 15px 0px 0px" : "0px" }} className="tableHeader" >{categoryName}</th>
          ))}
        </tr>
      </thead>
      <tbody >
        <tr >
          <td className="classAverage" style={{ background: "#FAFAFA", borderRadius: "9px 0px 0px 0px" }}>{Common.ClassAverage}</td>
          {subjectData?.map((n, index) => {
            return (<td key={index} className="rowElements" style={{ background: (index % 2 !== 0) ? "#FAFAFA" : "" }}><TableRowElement value={pupilAverage?.find(item => item.name === n)?.actual || 0} highest={(result?.maxPupilCategoryAverage?.name === n) ? true : false} lowest={(result?.minPupilCategoryAverage?.name === n) ? true : false} />
            </td>)
          }
          )}
        </tr>{result?.categoryMark?.map((name, rowIndex) => (
          <tr key={rowIndex} style={{ background: "#FAFAFA" }}>
            <td className="nameInnerText d-flex flex-column" style={{ background: "#FAFAFA" }}><span>{name.firstName + " " + name.lastName}</span>
              <div className=" d-flex flex-row">
                {Object.entries(name?.others).map(([key, value]) => {
                  if (value === true) {
                    return (
                      <div className="senStatus" key={rowIndex}>
                        <div className="dot" style={{ background: key === "pupilPremium" ? "#6D47FF" : "" || key === "eal" ? "#F4C900" : "" || key === "ehcp" || key === "senStatus" ? "#F50057" : "" }}></div>
                        <span className="nameText">{key === "pupilPremium" ? "PP" : "" || key === "senStatus" ? "SEND" : "" || key === "ehcp" ? "EHCP" : "" || key === "eal" ? "EAL" : ""}</span>
                      </div>
                    )
                  }
                })}
              </div>
            </td>
            {subjectData.map((d, index) => (
              <td className="rowElements" key={index} style={{ background: (index % 2 !== 0) ? "#FAFAFA" : "" }}><TableRowElement value={name?.category?.find((item) => item.name === d)?.actual || 0} highest={(name?.highest?.find(item => item.name === d)) ? true : false} lowest={(name?.lowest?.find(item => item.name === d)) ? true : false} />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </Table>}</>
  );
}

export { OverViewTable };